/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Fri Mar 26 2021 08:25:20 GMT+0100 (czas środkowoeuropejski standardowy)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';
import {
  tpAddressResponse,
  tpGeneralDataResponse,
  tpContactResponse,
} from '../services/thirdParty';
import {
  ParCommissionResponse,
  ParOffer,
  ParPricingStep,
  ParServiceResponse,
  ParServiceStep,
  PricingResponse,
} from './pricing';
import {
  PropElemAttributeResponse,
  PropThirdPartyResponse,
  Syndicationlist,
} from './proposal';
import { AssetFutureValueResponse, IrvSchedule } from './assets';

const URL = API_URLS.FINANCE;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface JobExecutionResponse {
  code: string;
  description: string;
  errorfile: string;
  jobid: number;
  logfile: string;
  message: string;
  outputfile: string;
  servicename: string;
}

export interface FindFinModificationByAnyRefOrStatusParams {
  ctreference: string;
  modevent: string;
  modstatus: string;
  ctrid?: number;
  modtype: string;
  creationuserid?: number;
}
export interface FinModification {
  creationdate: string;
  creationuserid: number;
  creationusername: string;
  ctreference: string;
  ctrid: number;
  eventlabel: string;
  lancode: string;
  modcomment: string;
  modevent: string;
  modexeclog: string;
  modid: number;
  modtype: string;
  modtypelabel: string;
  modrestorelog: string;
  modstatus: string;
  modstatuslabel: string;
  proctaskid: number;
  reviewdate: string;
  reviewuserid: number;
  reviewusername: string;
}

export interface FinModificationView {
  modid: number;
  modevent: string;
  eventlabel: string;
  modstatus: string;
  modstatuslabel: string;
  proctaskid: number;
  ctrid: number;
  ctreference: string;
  creationdate: string;
  creationuserid: number;
  creationusername: string;
  reviewdate: string;
  reviewuserid: number;
  reviewusername: string;
  modcomment: string;
  modexeclog: string;
  modrestorelog: string;
  lancode: string;
}

export interface FinModificationResponse {
  creationdate: string;
  creationuserid: number;
  creationusername: string;
  ctrid: number;
  eventlabel: string;
  lancode: string;
  modcomment: string;
  modevent: string;
  modexeclog: string;
  modid: number;
  modrestorelog: string;
  modstatus: string;
  modstatuslabel: string;
  proctaskid: number;
  reviewdate: string;
  reviewuserid: number;
  reviewusername: string;
  modeventlabel: string;
  proctasklabel: string;
  clientGeneralData: tpGeneralDataResponse;
  clientContact: tpContactResponse;
  clientAddress: tpAddressResponse;
  ctreference: string;
  ctdescription: string;
  currcode: string;
  simulParams: Array<FinModSimulParamsResponse>;
}

export interface FinModSimulParamsResponse {
  paramid: number;
  modid: number;
  partype: string;
  parcode: string;
  parcodelabel: string;
  entity: string;
  entitytype: string;
  entitytypelabel: string;
  entitycategory: string;
  entitycategorylabel: string;
  entityid: number;
  entitydescription: string;
  oldvalue: string;
  newvalue: string;
  taxcode: string;
  taxrate: number;
  taxamount: number;
  grossamount: number;
  parformat: string;
  parcomment: string;
  finModSimulParamAssets: Array<FinModSimulParamAssets>;
  finModSimulParamElements: Array<any>;
  feesamount: number;
  fees: string;
  feeslabel: string;
}

export interface FinModSimulParamAssets {
  assetid: number;
  modid: number;
  assetreference: string;
  assetlabel: string;
  assetnetamount: number;
  assetrvamount: number;
  finrvamount: number;
  rentalpart: number;
  irvamount: number;
  rvgap: number;
  targetphase: string;
  targetstatus: string;
  damage: string;
  degfeesformula: string;
  degfeesformulalabel: string;
  degfeesamount: number;
  spvalue: number;
  spformula: string;
  spformulalabel: string;
  spamount: number;
  saleamount: number;
  tpofformula: string;
  tpofformulalabel: string;
  tpofamount: number;
  fees: string;
  feeslabel: string;
  feesamount: string;
  totalinvoiceamount: number;
}

export interface CTUsedAmountResponse {
  commission: number;
  ctrid: number;
  depositused: number;
  disbursment: number;
  finamountused: number;
  firsrentalused: number;
  partused: number;
  rentalamountused: number;
  rvamountused: number;
  upfrontused: number;
}

export interface ConDecisionResponse {
  assetnote: string;
  assetreserve: boolean;
  coborrowernote: string;
  coborrowerreserve: boolean;
  created_at: string;
  created_by: number;
  ctrid: number;
  deccode: string;
  deccodelabel: string;
  deccomment: string;
  decdate: string;
  decexternalref: string;
  decisionid: number;
  declevel: string;
  declevellabel: string;
  decscore: string;
  dectype: string;
  deposit: number;
  depositapproved: number;
  depositreserve: boolean;
  duration: number;
  durationapproved: number;
  durationreserve: boolean;
  finamountapproved: number;
  finamountreserve: boolean;
  firspaymentapproved: number;
  firstpayment: number;
  firstpaymentreserve: boolean;
  guarantornote: string;
  guarantorreserve: boolean;
  insurancenote: string;
  insurancereserve: boolean;
  rate: number;
  rateapproved: number;
  ratereserve: boolean;
  reqfinamount: number;
  residualvalue: number;
  residualvalueapproved: number;
  residualvaluereserve: boolean;
  updated_at: string;
  updated_by: number;
  warrantynote: string;
  warrantyreserve: boolean;
}

export interface FinAsset {
  assetcategory: string;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmodel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetphase: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assettaxamount: number;
  assettype: string;
  chassisno: string;
  created_at: string;
  created_by: number;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  finAssetComponents: Array<FinAssetComponent>;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  last_action: string;
  plateno: string;
  power: string;
  priid: number;
  pritype: string;
  registrationno: string;
  serialno: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  updated_at: string;
  updated_by: number;
  weight: string;
}

export interface FinAssetComponent {
  compcategory: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  finAsset: FinAsset;
  taxcode: string;
  taxrate: number;
}

export interface FinAssetComponentResponse {
  assetid: number;
  compcategory: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  taxcode: string;
  taxrate: number;
}

export interface FinAssetRequest {
  assetcategory: string;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmodel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetphase: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assettaxamount: number;
  assettype: string;
  chassisno: string;
  created_at: string;
  created_by: number;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  finAssetComponents: Array<FinAssetComponent>;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  last_action: string;
  plateno: string;
  power: string;
  priid: number;
  pritype: string;
  registrationno: string;
  serialno: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  updated_by: number;
  updatedat: string;
  weight: string;
  networkcode: string;
  tpidbroker: number;
  assetfinamount: number;
  degfeesformula: number;
  spfeesformula: number;
  tpofformula: number;
}

export interface FinAssetResponse {
  assetcategory: string;
  assetcategorylabel: string;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmodel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetphase: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assettaxamount: number;
  assettype: string;
  assettypelabel: string;
  chassisno: string;
  created_at: string;
  created_by: number;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  finAssetComponents: Array<FinAssetComponentResponse>;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  last_action: string;
  plateno: string;
  power: string;
  priid: number;
  pritype: string;

  registrationno: string;
  serialno: string;
  statuslabel: string;
  suppliername: string;
  supplierreference: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  updated_by: number;
  updatedat: string;
  weight: string;
  outstandingamount: number;
  outstandingdate: string;
  assetrvamount: number;
  cteid: number;
  irvSchedule: Array<IrvScheduleResponse>;
  finrvamount: number;
  irvamount: number;
  rvgap: number;
  networkcode: string;
  tpidbroker: number;
  assetfinamount: number;
  degfeesformula: number;
  spfeesformula: number;
  tpofformula: number;

  brokername: string;
  brokerreference: string;
  listrv:any[];
  marksDuration?: any;
  listMarksMillageByDuration?: any;
  rvDuration?: any;
  rvamountByDuration?: any;
  catalogid?: number;
}

export interface FinCTListResponse {
  brid: number;
  brokername: string;
  clientname: string;
  ctactivationdate: string;
  ctdeliverydate: string;
  ctdescription: string;
  ctfinancedamount: number;
  ctnetworkcode: string;
  ctorderdate: string;
  ctphase: string;
  ctreference: string;
  ctrid: number;
  ctstage: string;
  ctstatus: string;
  ctstatusdate: string;
  mcid: number;
  mgid: number;
  offerid: number;
  offeridlabel: string;
  prcode: string;
  prcodelabel: string;
  propreference: string;
  statuslabel: string;
  tpidbroker: number;
  tpidclient: number;
  tprefbroker: string;
  tpreference: string;
  mfid: number;
  mfreference: string;
  currcode: string;
  cteduration: number;
  cteupfrontamount: number;
  ctervamount: number;
  ctefirstpayment: number;
  cterentalamount: number;
  ctepartamount: number;
  ctegraceperiodduration: number;
  ctedescription: string;
  assetpictureurl: string;
  catalogid: number;
  ctremainingduration: number;
  totalnotinvoicedrental: number;
  totalnotinvoicedservice: number;
  totalunpaidamount: number;
  totaloutstandingamount: number;
  ctfinmodevent: string;
  ctfinmodeventlabel: string;
  clientreference: string;
  ctnetworkcodelabel: string;
  cteid: number;
  ctenominalrate: number;
}

export interface FinConElemAssetRequest {
  assetid: number;
  associd: number;
  cteid: number;
  endate: string;
  finamountin: number;
  finamountout: number;
  fiscalamountin: number;
  fiscalamountout: number;
  free1: string;
  originalamount: number;
  startdate: string;
}

export interface FinConElemAssetResponse {
  assetdescription: string;
  assetid: number;
  assetreference: string;
  associd: number;
  cteid: number;
  endate: string;
  finamountin: number;
  finamountout: number;
  fiscalamountin: number;
  fiscalamountout: number;
  free1: string;
  originalamount: number;
  startdate: string;
}

export interface FinConElemScheduleRequest {
  ciid: number;
  cilid: number;
  cteid: number;
  ctesid: number;
  ctrid: number;
  ctsactuarialrate: number;
  ctsamortizedamount: number;
  ctsbasisamount: number;
  ctsbasisrate: number;
  ctsdepositbasis: number;
  ctsdepositinterest: number;
  ctsdepositrate: number;
  ctsduedate: string;
  ctsenddate: string;
  ctsid: number;
  ctsinterestamount: number;
  ctsorder: number;
  ctsoutstandingamount: number;
  ctsperiodicity: string;
  ctsrentalamount: number;
  ctsstartamount: number;
  ctsstartdate: string;
  ctsstatus: string;
  ctsterm: string;
  ctstype: string;
  taxcode: string;
}

export interface FinConElemScheduleResponse {
  ciid: number;
  cilid: number;
  cteid: number;
  ctesid: number;
  ctrid: number;
  ctsactuarialrate: number;
  ctsamortizedamount: number;
  ctsbasisamount: number;
  ctsbasisrate: number;
  ctsdepositbasis: number;
  ctsdepositinterest: number;
  ctsdepositrate: number;
  ctsduedate: string;
  ctsenddate: string;
  ctsid: number;
  cireference: string;
  ctsinterestamount: number;
  ctsorder: number;
  ctsoutstandingamount: number;
  ctsperiodicity: string;
  ctsrentalamount: number;
  ctsstartamount: number;
  ctsstartdate: string;
  ctsstatus: string;
  ctsterm: string;
  ctstermlabel: string;
  ctstype: string;
  ctstypelabel: string;
  statuslabel: string;
  taxcode: string;
  taxcodelabel: string;
  ctstaxcode: string;
  ctstaxrate: number;
  ctstaxamount: number;
  ctstotalamount: number;
  ctsdiscountcoef: number;
  ctsdiscountoutstanding: number;
  ctsagiosdeb: number;
  ctsvatdeffered: number;

  ctsdiscountinterest: number;

  ctsdiscountagiosdeb: number;
}

export interface FinConElemSpreading {
  accountingdate: string;
  accountingreference: string;
  cteid: number;
  ctrid: number;
  ctsamortizedamount: number;
  ctscategory: string;
  ctsdirection: string;
  ctsduedate: string;
  ctsenddate: string;
  ctsid: number;
  ctsinterestamount: number;
  ctsnominalrate: number;
  ctsorder: number;
  ctsoutstandingamount: number;
  ctsrentalamount: number;
  ctsstartamount: number;
  ctsstartdate: string;
  ctsstatus: string;
  ctstype: string;
}

export interface FinConElemStepRequest {
  cteid: number;
  ctesamortizedcoef: number;
  ctesduration: number;
  ctesyear: number;
  ctesyearend: number;
  ctesid: number;
  ctesorder: number;
  ctesperiodicity: string;
  ctesrentalamount: number;
  ctesrentalcoef: number;
  ctrid: number;
}

export interface FinConElemStepResponse {
  ctesoutstandingcoef: number;
  cteid: number;
  ctesamortizedcoef: number;
  ctesduration: number;
  ctesid: number;
  ctesorder: number;
  ctesyear: number;
  ctesyearend: number;
  ctesoutstandingamount: number;
  ctesperiodicity: string;
  ctesperiodicityunit: string;
  ctesperiodicityunitlabel: string;
  ctesrentalamount: number;
  ctesrentalcoef: number;
  ctrid: number;
  status: string;
}

export interface FinConElementRequest {
  assetid: number;
  servbasis: number;
  cteactuarialrate: number;
  ctecalculationbasis: string;
  ctecalculationtype: string;
  ctecategory: string;
  ctedeferredinterest: number;
  ctedeferredinterestmethod: string;
  ctedeferredinterestnominalrate: number;
  ctedepositamount: number;
  ctedepositcoef: number;
  ctedepositinterest: number;
  ctedepositinterestmethod: string;
  ctedepositnominalrate: number;
  ctedescription: string;
  ctedirection: string;
  cteduration: number;
  cteendamount: number;
  cteenddate: string;
  ctefinancedamount: number;
  ctefirstpayment: number;
  ctefirstpaymentcoef: number;
  ctefirstpaymentdate: string;
  ctefree1: string;
  ctegraceperiodduration: number;
  ctegraceperiodmethod: string;
  cteid: number;
  cteidparent: number;
  cteinitialamount: number;
  cteinstallmentamount: number;
  cteinterestmethod: string;
  cteinvestamount: number;
  ctenominalrate: number;
  cteorder: number;
  ctepartamount: number;
  ctepartdays: number;
  ctepartmethod: string;
  ctepartrate: number;
  ctepaymentterm: string;
  cteperiodicity: string;
  cteratebasis: string;
  cterateformula: string;
  cterateperiodicity: string;
  cteratespread: number;
  cterateterm: string;
  cteratetype: string;
  cterentalamount: number;
  ctervamount: number;
  ctervcoef: number;
  ctestartamount: number;
  ctestartdate: string;
  ctestatus: string;
  ctetype: string;
  cteunit: string;
  cteupfrontamount: number;
  ctrid: number;
  currcode: string;
  finConElemAssets: Array<FinConElemAssetRequest>;
  finConElemSchedules: Array<FinConElemScheduleRequest>;
  finConElemSteps: Array<FinConElemStepRequest>;
  last_action: string;
  prefinbasis: string;
  prefinmethod: string;
  prefinnominalrate: number;
  prefinperiodicity: string;
  prefinrateformula: string;
  prefinratetype: string;
  priid: number;
  taxcode: string;
  tpid: number;
  tpidparticipation: number;
  spvassetdiscount: number;
  spvriskrate: number;
  spvadditionalfees: number;
  spvloancoef: number;
  spvdiscountsale: number;
  spvinflation: number;
  cteidrefin: number;
  ctridrefin: number;
}

export interface FinElemPrefinStepResponse {
  cteid: number;
  ctrid: number;
  ctesid: number;
  ctesorder: number;
  ctesstartdate: string;
  ctesduration: number;
  ctesperiodicityunit: string;
  ctesperiodicity: string;
  enddate: string;
  calmethod: string;
  rateformula: string;
  ratebasis: string;
  ratespread: number;
  nominalrate: number;
  ctesstartamount: number;
  ctesinterestamount: number;
  ctesamortizedcoef: number;
  ctesamortizedamount: number;
  ctesrentalamount: number;
  ctesoutstandingcoef: number;
  ctesoutstandingamount: number;
}

export interface FinConElementResponse {
  conElemAttributes: Array<PropElemAttributeResponse>;
  marginratemin: number;
  marginratemax: number;
  margincontextmin: number;
  margincontextmax: number;
  servbasis: number;
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
  servfixedamount: number;
  servpercentage: number;
  rvcalculationmode: string;
  rvevaluationmode: string;
  prefinrateref: number;
  prefinratespread: number;
  cterateref: number;
  serviceResponse: ParServiceResponse;
  commissionResponse: ParCommissionResponse;
  serviceStepList: Array<ParServiceStep>;
  pricingStepList: Array<ParPricingStep>;
  conElemSteps: Array<FinConElemStepResponse>;
  conElemPrefinSteps: Array<FinElemPrefinStepResponse>;
  assetdescription: string;
  assetid: number;
  assetreference: string;
  cteactuarialrate: number;
  ctecalculationbasis: string;
  ctecalculationbasislabel: string;
  ctecalculationtype: string;
  ctecalculationtypelabel: string;
  ctecategory: string;
  ctecategorylabel: string;
  ctedeferredinterest: number;
  ctedeferredinterestmethod: string;
  ctedeferredinterestmethodlabel: string;
  ctedeferredinterestnominalrate: number;
  ctedepositamount: number;
  ctedepositcoef: number;
  ctedepositinterest: number;
  ctedepositinterestmethod: string;
  ctedepositinterestmethodlabel: string;
  ctedepositnominalrate: number;
  ctedescription: string;
  ctedirection: string;
  ctedirectionlabel: string;
  cteduration: number;
  cteendamount: number;
  cteenddate: string;
  ctefinancedamount: number;
  ctefirstpayment: number;
  ctefirstpaymentcoef: number;
  ctefirstpaymentdate: string;
  ctefree1: string;
  ctegraceperiodduration: number;
  ctegraceperiodmethod: string;
  ctegraceperiodmethodlabel: string;
  cteid: number;
  cteidparent: number;
  cteidparentorder: number;
  cteinitialamount: number;
  cteinstallmentamount: number;
  cteinterestmethod: string;
  cteinvestamount: number;
  ctenominalrate: number;
  cteorder: number;
  ctepartamount: number;
  ctepartdays: number;
  ctepartmethod: string;
  ctepartmethodlabel: string;
  ctepartrate: number;
  ctepaymentterm: string;
  ctepaymenttermlabel: string;
  cteperiodicity: string;
  cteperiodicitylabel: string;
  cteratebasis: string;
  cterateformula: string;
  cterateperiodicity: string;
  cteratespread: number;
  cterateterm: string;
  cteratetype: string;
  cterentalamount: number;
  ctervamount: number;
  ctervcoef: number;
  ctestartamount: number;
  ctestartdate: string;
  ctestatus: string;
  ctestatuslabel: string;
  ctetype: string;
  ctetypelabel: string;
  cteunit: string;
  cteunitlabel: string;
  cteupfrontamount: number;
  ctrid: number;
  currcode: string;
  ctemileage: number;
  ctepriidexceed: number;
  conElemAssets: Array<FinConElemAssetResponse>;
  conElemIFRS: Array<FinConElemSpreading>;
  conElemSchedules: Array<FinConElemScheduleResponse>;
  conElemSpreading: Array<FinConElemSpreading>;
  finConElemSteps: Array<FinConElemStepResponse>;
  last_action: string;
  prefinbasis: string;
  prefinmethod: string;
  prefinnominalrate: number;
  prefinperiodicity: string;
  prefinrateformula: string;
  prefinratetype: string;
  pricing: PricingResponse;
  priid: number;
  prilabel: string;
  taxcode: string;
  taxrate: number;
  taxtype: string;
  tpid: number;
  tpidparticipation: number;
  tpname: string;
  tpnamepart: string;
  ctebilligdate: string;
  spvassetdiscount: number;
  spvriskrate: number;
  spvadditionalfees: number;
  spvloancoef: number;
  spvdiscountsale: number;
  spvinflation: number;
  spvassetdiscountamount: number;
  spvloanamount: number;
  spvriskamount: number;
  spvfeesamount: number;

  rvauthid: number;
  rvtaskid: number;
  rateauthid: number;
  ratetaskid: number;
  frauthid: number;
  frtaskid: number;
  durationauthid: number;
  durationtaskid: number;
  servtaskid: number;
  servauthid: number;
  margintaskid: number;
  marginauthid: number;
  ctefeesamount: number;
  ctecommissionamount: number;
  cteprofitabilityrate: number;
  cteaprrate: number;
  cteflatrate: number;
  ctecoefrate: number;
  ctefundingrate: number;
  ctefundingperiodicity: number;
  ctefundinginstallment: number;
  ctefundingcost: number;
  ctemarginamount: number;
  ctemarginrate: number;
  ctevatdeferralamount: number;
  ctevatdeferralduration: number;
  ctevatdeferralmethod: string;
  ctevatdeferraldaysbasis: string;
  cteextracosttofinance: number;
  cteextracostcomment: string;
  fundingSchedule: Array<FinConElemScheduleResponse>;
  totalInterest: number;
  totalRental: number;
  totalAmortization: number;
  totaldiscountedInterest: number;
  totalVatDeffered: number;
  totaldiscountedOutstanding: number;
  totaldiscountedAgiosdeb: number;
  totalAgiosdeb: number;
  marginImpactCredit: number;
  marginImpactDebit: number;
  dgo: number;
  profitabilityAmount: number;
  ceilingrate: number;
  ceilingdefaultrate: number;
  floorrate: number;
  floordefaultrate: number;
  calid: number;
  servuseunit:string;
  servusefrequency:string;
  servuseqty:number;
  servuseminamount:number;
  servusemaxamount:number;
  servusecoverage:number;
  servusedeductionamount:number;
  servusedeductionpercenrage:number;
  servdescription:string,
  ctridrefin: number;
  cteidrefin: number;
}

export interface FinConElementViewResponse {
  assetdescription: string;
  assetid: number;
  assetreference: string;
  cteactuarialrate: number;
  ctecalculationbasis: string;
  ctecalculationbasislabel: string;
  ctecalculationtype: string;
  ctecalculationtypelabel: string;
  ctecategory: string;
  ctecategorylabel: string;
  ctedeferredinterest: number;
  ctedeferredinterestmethod: string;
  ctedeferredinterestmethodlabel: string;
  ctedeferredinterestnominalrate: number;
  ctedepositamount: number;
  ctedepositcoef: number;
  ctedepositinterest: number;
  ctedepositinterestmethod: string;
  ctedepositinterestmethodlabel: string;
  ctedepositnominalrate: number;
  ctedescription: string;
  ctedirection: string;
  ctedirectionlabel: string;
  cteduration: number;
  cteendamount: number;
  cteenddate: string;
  ctefinancedamount: number;
  ctefirstpayment: number;
  ctefirstpaymentcoef: number;
  ctefirstpaymentdate: string;
  ctefree1: string;
  ctegraceperiodduration: number;
  ctegraceperiodmethod: string;
  ctegraceperiodmethodlabel: string;
  cteid: number;
  cteidparent: number;
  cteidparentorder: number;
  cteinitialamount: number;
  cteinstallmentamount: number;
  cteinterestmethod: string;
  cteinvestamount: number;
  ctenominalrate: number;
  cteorder: number;
  ctepartamount: number;
  ctepartdays: number;
  ctepartmethod: string;
  ctepartmethodlabel: string;
  ctepartrate: number;
  ctepaymentterm: string;
  ctepaymenttermlabel: string;
  cteperiodicity: string;
  cteperiodicitylabel: string;
  cteratebasis: string;
  cterateformula: string;
  cterateperiodicity: string;
  cteratespread: number;
  cterateterm: string;
  cteratetype: string;
  cterentalamount: number;
  ctervamount: number;
  ctervcoef: number;
  ctestartamount: number;
  ctestartdate: string;
  ctestatus: string;
  ctestatuslabel: string;
  ctetype: string;
  ctetypelabel: string;
  cteunit: string;
  cteunitlabel: string;
  cteupfrontamount: number;
  ctrid: number;
  currcode: string;
  last_action: string;
  prefinbasis: string;
  prefinmethod: string;
  prefinnominalrate: number;
  prefinperiodicity: string;
  prefinrateformula: string;
  prefinratetype: string;
  pricing: Pricing;
  priid: number;
  prilabel: string;
  taxcode: string;
  taxrate: number;
  tpid: number;
  tpidparticipation: number;
  tpname: string;
  tpnamepart: string;
  outstandingamount: number;
  outstandingdate: number;
}

export interface FinContract {
  brid: number;
  ctacceptancedate: string;
  ctactivationdate: string;
  ctbankname: string;
  ctbic: string;
  ctbillingdate: string;
  ctbouserdate: string;
  ctbouserid: number;
  ctcbdate: string;
  ctcbkey: string;
  ctcbname: string;
  ctcbnum: string;
  ctcbtype: string;
  ctdeliverydate: string;
  ctdescription: string;
  ctenddate: string;
  ctfclevel: string;
  ctfinancedamount: number;
  ctflagreminder: boolean;
  ctfree1: string;
  ctfree2: string;
  ctfree3: string;
  ctfree4: string;
  ctiban: string;
  ctidautorization: number;
  ctinitenddate: string;
  ctinitstartdate: string;
  ctinvoiceaddresscity: string;
  ctinvoiceaddressname: string;
  ctinvoiceaddressstr1: string;
  ctinvoiceaddressstr2: string;
  ctinvoiceaddresszipcode: string;
  ctinvoicesendingmode: string;
  ctinvoicingmode: string;
  ctlateinterestformula: string;
  ctlpuserdate: string;
  ctlpuserid: number;
  ctnetworkcode: string;
  ctorderdate: string;
  ctpartialpayoffformula: string;
  ctpaymentdelay: number;
  ctpaymentmode: string;
  ctphase: string;
  ctrecuserdate: string;
  ctrecuserid: number;
  ctreference: string;
  ctrequestdate: string;
  ctrid: number;
  ctriskstatus: string;
  ctriskstatusdate: string;
  ctriskuserdate: string;
  ctriskuserid: number;
  ctsaleuserdate: string;
  ctsaleuserid: number;
  ctstage: string;
  ctstatus: string;
  ctstatusdate: string;
  cttotalpayoffformula: string;
  cttype: string;
  currcode: string;
  finAssets: Array<FinAssetRequest>;
  finConElements: Array<FinConElementRequest>;
  last_action: string;
  mcid: number;
  mgid: number;
  offerid: number;
  prcode: string;
  priid: number;
  pritype: string;
  propreference: string;
  tpidbroker: number;
  tpidclient: number;
  tpidcoborrower: number;
  tpidguarantor: number;
  tpidsupplier: number;
  tpinvoiceaddressregion: string;
}

export interface FinContractRequest {
  brid: number;
  ctcomment: string;
  ctacceptancedate: string;
  ctactivationdate: string;
  ctbankname: string;
  ctbic: string;
  ctbillingdate: string;
  ctbouserdate: string;
  ctbouserid: number;
  ctcbdate: string;
  ctcbkey: string;
  ctcbname: string;
  ctcbnum: string;
  ctcbtype: string;
  ctdeliverydate: string;
  ctdescription: string;
  ctenddate: string;
  ctfclevel: string;
  ctfinancedamount: number;
  ctflagreminder: boolean;
  ctfree1: string;
  ctfree2: string;
  ctfree3: string;
  ctfree4: string;
  ctiban: string;
  ctidautorization: number;
  ctinitenddate: string;
  ctinitstartdate: string;
  ctinvoiceaddresscity: string;
  ctinvoiceaddressname: string;
  ctinvoiceaddressstr1: string;
  ctinvoiceaddressstr2: string;
  ctinvoiceaddresszipcode: string;
  ctinvoicesendingmode: string;
  ctinvoicingmode: string;
  ctlateinterestformula: string;
  ctlpuserdate: string;
  ctlpuserid: number;
  ctnetworkcode: string;
  ctorderdate: string;
  ctpartialpayoffformula: string;
  ctpaymentdelay: number;
  ctpaymentmode: string;
  ctphase: string;
  ctrecuserdate: string;
  ctrecuserid: number;
  ctreference: string;
  ctrequestdate: string;
  ctrid: number;
  ctriskstatus: string;
  ctriskstatusdate: string;
  ctriskuserdate: string;
  ctriskuserid: number;
  ctsaleuserdate: string;
  ctsaleuserid: number;
  ctstage: string;
  ctstatus: string;
  ctstatusdate: string;
  cttotalpayoffformula: string;
  cttype: string;
  currcode: string;
  finAssets: Array<FinAssetRequest>;
  finConElements: Array<FinConElementRequest>;
  last_action: string;
  mcid: number;
  mgid: number;
  offerid: number;
  prcode: string;
  priid: number;
  pritype: string;
  propreference: string;
  tpidbroker: number;
  tpidclient: number;
  tpidcoborrower: number;
  tpidguarantor: number;
  tpidsupplier: number;
  tpinvoiceaddressregion: string;
  ctsyndinvoicingtype: string;
  ctsyndsuppliermanagementtype: string;
  ctsyndpaymentmanagementtype: string;
  ctsyndmgcoef: number;
  ctsyndmgpartamount: number;
  tpidsyndlead: number;
  ctmodificationfeesformula: string;
  ctdegradationfeesformula: string;
  ceilingrate: number;
  ceilingdefaultrate: number;
  floorrate: number;
  floordefaultrate: number;
  calid: number;
}

export interface FinContractViewResponse {
  ctrid: number;
  branchname: string;
  brid: number;
  ctreference: string;
  clientname: string;
  clientreference: string;
  ctacceptancedate: string;
  ctactivationdate: string;
  ctdeliverydate: string;
  ctdescription: string;
  ctenddate: string;
  ctfclevel: string;
  ctfinancedamount: number;
  ctnetworkcode: string;
  ctorderdate: string;
  ctphase: string;
  ctphaselabel: string;
  ctstatus: string;
  ctstatusdate: string;
  ctstatuslabel: string;
  assets: Array<FinAssetResponse>;
  elements: Array<FinConElementViewResponse>;
  mgid: number;
  offerid: number;
  offerlabel: string;
  prcode: string;
  propreference: string;
  tpidclient: number;
  ctduration: number;
  ctdurationunit: number;
  ctremainingduration: number;
  evaluationdate: string;
  rvamount: number;
  totalunpaidamount: number;
  totaloutstandingamount: number;
  outstandingdate: string;
  nextinvoicenetamount: number;
  nextinvoicetaxamount: number;
  nextinvoicedate: string;
}

export interface IrvScheduleResponse {
  irvid: number;
  irvorder: number;
  startdate: string;
  enddate: string;
  rvpercentage: number;
  irvamount: number;
  finrvamount: number;
  rvgap: number;
  trg: number;
  finrvwithtrg: number;
  rvgapwithtrg: number;
  accountingdate: string;
  accountingreference: string;
  rentalpart: number;
  interestpart: number;
  capitalpart: number;
  ctstype: string;
}

export interface ConLoanRedemptionResponse{
  redempid: number;
  ctreorigin: string;
  ctridlinked: number;
  ctrid: number;
  mgid: number;
  ctredstartdate: string;
  ctredenddate: string;
  ctredremainduration: number;
  ctredactivitydate: string;
  ctredfinancedamount: number;
  ctredoutstandingamount: number;
  ctredunpaidamount: number;
  tpofformula: number;
  tpofamount: number;
  tpoftoinvoice: number;
  ctredtotalamount: number;
  tpredbenef: number;
  tpredbenefname: string;
  tpredbenefreference: string;
  ctredreference: string;
}

export interface ConLoanRedemptionRequest{
  redempid: number;
  ctreorigin: string;
  ctridlinked: number;
  ctrid: number;
  mgid: number;
  ctredstartdate: string;
  ctredenddate: string;
  ctredremainduration: number;
  ctredactivitydate: string;
  ctredfinancedamount: number;
  ctredoutstandingamount: number;
  ctredunpaidamount: number;
  tpofformula: number;
  tpofamount: number;
  tpoftoinvoice: number;
  ctredtotalamount: number;
  tpredbenef: number;
  ctredreference: string;
}

export interface ThirdPartyResponse {
  address: tpAddressResponse;
  contact: tpContactResponse;
  generalData: tpGeneralDataResponse;
}
export interface FinContractResponse {
  ctcomment: string;
  ctreversalreasonlabel: string;
  catalogid: number;
  ctdurationmonths: number;
  ctegraceperiodmethod: string;
  ctegraceperiodduration: number;
  assetpictureurl: string;
  ctsyndinvoicingtype: string;
  ctsyndsuppliermanagementtype: string;
  ctsyndpaymentmanagementtype: string;
  ctsyndmgcoef: number;
  ctsyndmgpartamount: number;
  offer: ParOffer;
  ctvaliditydate: string;
  ctmodificationfeesformula: string;
  ctdegradationfeesformula: string;
  branchname: string;
  syndication: Array<Syndicationlist>;
  thirdParties: Array<PropThirdPartyResponse>;
  clientData?: ThirdPartyResponse;
  tpidsyndlead: number;
  syndleadname: string;
  syndleadreference: string;
  branchreference: string;
  brid: number;
  brokername: string;
  brokerreference: string;
  clientname: string;
  clientreference: string;
  cobname: string;
  cobreference: string;
  ctacceptancedate: string;
  ctsignaturedate: string;
  ctactivationdate: string;
  ctbankname: string;
  ctbic: string;
  ctbillingdate: string;
  ctbouserdate: string;
  ctbouserid: number;
  ctcbdate: string;
  ctcbkey: string;
  ctcbname: string;
  ctcbnum: string;
  ctcbtype: string;
  ctdecisioncode: string;
  ctdecisioncodelabel: string;
  ctdecisioncomment: string;
  ctdecisiondate: string;
  ctdecisionlevel: string;
  ctdecisionlevellabel: string;
  ctdecisiontype: string;
  ctdeliverydate: string;
  ctdescription: string;
  ctenddate: string;
  ctfclevel: string;
  ctfinancedamount: number;
  ctflagreminder: boolean;
  ctfree1: string;
  ctfree2: string;
  ctfree3: string;
  ctfree4: string;
  ctiban: string;
  ctidautorization: number;
  ctinitenddate: string;
  ctinitstartdate: string;
  ctinvoiceaddresscity: string;
  ctinvoiceaddresscitylabel: string;
  ctinvoiceaddressname: string;
  ctinvoiceaddressstr1: string;
  ctinvoiceaddressstr2: string;
  ctinvoiceaddresszipcode: string;
  ctinvoicesendingmode: string;
  ctinvoicingmode: string;
  ctlateinterestformula: string;
  ctlpuserdate: string;
  ctlpuserid: number;
  ctnetworkcode: string;
  ctorderdate: string;
  ctpartialpayoffformula: string;
  ctpaymentdelay: number;
  ctpaymentmode: string;
  ctphase: string;
  ctphaselabel: string;
  ctrecuserdate: string;
  ctrecuserid: number;
  ctreference: string;
  ctrequestdate: string;
  ctrid: number;
  ctriskstatus: string;
  ctriskstatusdate: string;
  ctriskuserdate: string;
  ctriskuserid: number;
  ctsaleuserdate: string;
  ctsaleuserid: number;
  ctstage: string;
  ctstatus: string;
  ctstatusdate: string;
  ctstatuslabel: string;
  cttotalpayoffformula: string;
  cttype: string;
  currcode: string;
  assets: Array<FinAssetResponse>;
  conElements: Array<FinConElementResponse>;
  guarantorname: string;
  guarantorreference: string;
  last_action: string;
  mcid: number;
  mgid: number;
  offerid: number;
  offerlabel: string;
  prcode: string;
  priid: number;
  prilabel: string;
  pritype: string;
  propreference: string;
  suppliername: string;
  supplierreference: string;
  tpidbroker: number;
  tpidclient: number;
  tpidcoborrower: number;
  tpidguarantor: number;
  tpidsupplier: number;
  tpinvoiceaddressregion: string;
  flagmasterfacility: boolean;
  flagrealestate: boolean;
  flagasset: boolean;
  flagfleet: boolean;
  mfprcode: string;
  mfagreedamount: number;
  mfavailableamount: number;
  mfbookedamount: number;
  mfflagrevolving: boolean;
  mfrequestedamount: number;
  mfusedamount: number;
  mfvaliditydate: string;
  totalunpaidamount: number;
  ctenominalrate: number;
  ctervamount: number;
  cteduration: number;

  ctendofterm: string;
  ctendoftermtaskid: number;
  ctendoftermdelay: string;
  ctchannelcode: string;
  vendorid: any;
  flaguseassetgrossamount: boolean;
  flagretailer: boolean;
  conLoanRedemption: Array<ConLoanRedemptionResponse>;
  flagredemption: boolean;
}

export interface ClientInvoiceResponse {
  accountingdate: string;
  accountingreference: string;
  amortizedamount: number;
  assetcategory: string;
  assetcategorylabel: string;
  assettype: string;
  assettypelabel: string;
  bouseremail: string;
  bousername: string;
  bousertel: string;
  cidocdate: string;
  cidocdatecreditnote: string;
  cidocreference: string;
  cidueamount: number;
  cigrosstotal: number;
  ciid: number;
  ciidcreditnote: number;
  ciidinvoicelateinterest: number;
  ciidinvoicerejectfees: number;
  ciinvoicetype: string;
  ciinvoicetypelabel: string;
  cilateinterestcalculatedamount: number;
  cilateinterestcalculateddate: string;
  cilateinterestinvoicedamount: number;
  cilineadditionaltext: string;
  cimultiplecontracts: boolean;
  cinettotal: number;
  cipaymentdate: string;
  cipaymentdelaycode: string;
  cipaymentmode: string;
  cireference: string;
  cirejected: boolean;
  cirejecteddate: string;
  cirejectedfeesinvoicedamount: number;
  cirejectfeesamount: number;
  cispecificcondition: string;
  cistatus: string;
  citaxtotal: number;
  citype: string;
  citypelabel: string;
  clientname: string;
  clientreference: string;
  clientsurname: string;
  contractname: string;
  created_at: string;
  created_atcreditnote: string;
  created_by: number;
  ctinvoicesendingmode: string;
  ctinvoicingmode: string;
  ctreference: string;
  ctrid: number;
  currcode: string;
  flagPrinted: boolean;
  flagemail: boolean;
  interestamount: number;
  jobid: number;
  jobidemail: number;
  jobidprint: number;
  mgid: number;
  printid:number;
  psduration: number;
  psid: number;
  psorder: number;
  recuseremail: string;
  recusername: string;
  recusertel: string;
  refinvoicecreditnote: string;
  refinvoicelateinterest: string;
  refinvoicerejectfees: string;
  saleuseremail: string;
  saleusername: string;
  saleusertel: string;
  statuslabel: string;
  tpcontactname: string;
  tpemail1: string;
  tpfiscalid: string;
  tpidclient: number;
  tpinvoicingaddress: string;
  tpinvoicingaddress2: string;
  tpinvoicingcity: string;
  tpinvoicingregion: string;
  tpinvoicingzipcode: string;
  tplegalform: string;
  tpmanagername: string;
  tpsalutationcode: string;
  tpsalutationcodelabel: string;
  tptaxid: string;
  tptel1: string;
  tptelmobile1: string;
  updated_at: string;
  updated_by: number;
}

export interface Pricing {
  calculationbasis: string;
  calculationmethod: string;
  ctecategory: string;
  ctetype: string;
  deferredinterestmethod: string;
  deferredinterestnominalrate: number;
  depositamount: number;
  depositcoef: number;
  depositinterestmethod: string;
  depositnominalrate: number;
  durationdefault: number;
  durationmax: number;
  durationmin: number;
  durationreqreceiverid: number;
  durationreqreceiverroleprofile: string;
  durationreqreceivertype: string;
  durationreqtype: string;
  enddate: string;
  finamountmax: number;
  finamountmin: number;
  firstrentaldefault: number;
  firstrentalmax: number;
  firstrentalmin: number;
  firstrentalreqreceiverid: number;
  firstrentalreqreceiverroleprofile: string;
  firstrentalreqreceivertype: string;
  firstrentalreqtype: string;
  flagfollowgraceperiod: boolean;
  flagmandatory: boolean;
  flagupdate: boolean;
  gpduration: number;
  gpmethod: string;
  interestmethod: string;
  periodicity: string;
  pridescription: string;
  priid: number;
  prilabel: string;
  pristatus: string;
  rateformula: string;
  rateperiodicity: number;
  ratereqreceiverid: number;
  ratereqreceiverroleprofile: string;
  ratereqreceivertype: string;
  ratereqtype: string;
  ratespreaddefault: number;
  ratespreadmax: number;
  ratespreadmin: number;
  ratetype: string;
  ratevaluedefault: number;
  rvdefault: number;
  rvdefaultamount: number;
  rvmax: number;
  rvmin: number;
  rvreqreceiverid: number;
  rvreqreceiverroleprofile: string;
  rvreqreceivertype: string;
  rvreqtype: string;
  servcalculationmethod: string;
  servfixedamount: number;
  servfixedamountmin: number;
  serviceduration: string;
  servpercentage: number;
  servpercentagemin: number;
  servreqreceiverid: number;
  servreqreceiverroleprofile: string;
  servreqreceivertype: string;
  servreqtype: string;
  startdate: string;
  taxcode: string;
  term: string;
  unit: string;
  upfrontmin: number;
  upfrontmax: number;
  upfrontdefault: number;
}

export interface EvollisExecuteContractOperationParams {
  Operation: string;
  id_transaction: number;
  salegrossamount?: number;
  salenetamount?: number;
  saletaxamount?: number;
  targetdate?: string;
  targetstatus?: string;
  tpidbuyer?: number;
}
export interface ChangeAdrressParams {
  ctrid: number;
  feesAmount: number;
  feesFormula: string;
  feesTax: number;
  feesTaxcode: string;
  feesTaxrate: number;
  feescategory: string;
  feestype: string;
  proctaskid: number;
  targetdate: string;
  tpadrid: number;
  tpid: number;
}

export interface ChangeBankAccountParams {
  ctrid: number;
  feesAmount: number;
  feesFormula: string;
  feesTax: number;
  feesTaxcode: string;
  feesTaxrate: number;
  feescategory: string;
  feestype: string;
  proctaskid: number;
  targetdate: string;
  tpbkid: number;
  tpid: number;
}
export interface FinContAddressRequest {
  ctinvoiceaddresscity: string;
  ctinvoiceaddressstr1: string;
  ctinvoiceaddressstr2: string;
  ctinvoiceaddresszipcode: string;
  tpinvoiceaddressregion: string;
}
export interface ConStatusResponse {
  ctphase: string;
  ctphaselabel: string;
  ctrid: number;
  ctstatus: string;
  ctstatusdate: string;
  ctstatuslabel: string;
  id: number;
  updated_at: string;
  userid: number;
  username: string;
}

export interface TpAddress {
  adrenddate: string;
  adrstartdate: string;
  adrstatus: string;
  adrstatusdate: string;
  adrtype: string;
  tpadrid: number;
  tpid: number;
  tpmainadrcity: string;
  tpmainadrcountry: string;
  tpmainadrregion: string;
  tpmainadrstreet1: string;
  tpmainadrstreet2: string;
  tpmainadrzipcode: string;
}

export interface TpBankAccount {
  bkaccountkey: string;
  bkaccountnum: string;
  bkbranchcode: string;
  bkcode: string;
  bkenddate: string;
  bkstartdate: string;
  bkstatus: string;
  bkstatusdate: string;
  bktype: string;
  countcode: string;
  currcode: string;
  tpbankname: string;
  tpbic: string;
  tpbkid: number;
  tpcbdate: string;
  tpcbkey: string;
  tpcbname: string;
  tpcbnum: string;
  tpcbtype: string;
  tpiban: string;
  tpid: number;
}

export interface FinConThirdPartyRequest {
  address: TpAddress;
  bankAccountIn: TpBankAccount;
  bankAccountOut: TpBankAccount;
  ctrid: number;
  enddate: string;
  mfagreedamount: number;
  mfavailableamount: number;
  mfbookedamount: number;
  mfrequestedamount: number;
  mfusedamount: number;
  mfvaliditydate: string;
  startdate: string;
  status: string;
  statusdate: string;
  tpadrid: number;
  tpbkidin: number;
  tpbkidout: number;
  tpblocklateinterestinvoicing: boolean;
  tpblockrejectionfeesinvoicing: boolean;
  tpblockreminderfeesinvoicing: boolean;
  tpid: number;
  tplateinterestformula: string;
  tpmandatedate: string;
  tpname: string;
  tppaydelayin: string;
  tppaydelayout: string;
  tppaymodein: string;
  tppaymodeout: string;
  tpreference: string;
  tprejectionfeesformula: string;
  tpreminderfeesformula: string;
  tprolecode: string;
  tprolecodelabel: string;
  tproleid: number;
}

export interface FinConThirdPartyResponse {
  address: TpAddress;
  bankAccountIn: TpBankAccount;
  bankAccountOut: TpBankAccount;
  ctrid: number;
  enddate: string;
  mfagreedamount: number;
  mfavailableamount: number;
  mfbookedamount: number;
  mfrequestedamount: number;
  mfusedamount: number;
  mfvaliditydate: string;
  startdate: string;
  status: string;
  statusdate: string;
  tpadrid: number;
  tpbkidin: number;
  tpbkidout: number;
  tpblocklateinterestinvoicing: boolean;
  tpblockrejectionfeesinvoicing: boolean;
  tpblockreminderfeesinvoicing: boolean;
  tpid: number;
  tplateinterestformula: string;
  tpname: string;
  tppaydelayin: string;
  tppaydelayout: string;
  tppaymodein: string;
  tppaymodeout: string;
  tpreference: string;
  tprejectionfeesformula: string;
  tpreminderfeesformula: string;
  tprolecode: string;
  tprolecodelabel: string;
  tproleid: number;
}

export interface UpdateFinContractAddressParams {
  ctrid: number;
  finContAddressRequest: FinContAddressRequest;
}

/**
 * @tags Fin Contract Controller
 * @summary updateFinContractAddress
 */
export function updateFinContractAddress(
  params: UpdateFinContractAddressParams
) {
  return request.put<AbstractResponse<FinContractResponse, object>>(
    `${URL}/api/changeAddress/${params.ctrid}`,
    params.finContAddressRequest
  );
}
/**
 * @tags Fin Contract Controller
 * @summary changeBankAccount
 */
export function changeBankAccount(params: ChangeBankAccountParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/changeBkContract/${params.ctrid}` +
      prepareQueryParams({
        feesAmount: params.feesAmount,
        feesFormula: params.feesFormula,
        feesTax: params.feesTax,
        feesTaxcode: params.feesTaxcode,
        feesTaxrate: params.feesTaxrate,
        feescategory: params.feescategory,
        feestype: params.feestype,
        proctaskid: params.proctaskid,
        targetdate: params.targetdate,
        tpbkid: params.tpbkid,
        tpid: params.tpid,
      } as any)
  );
}
/**
 * @tags Fin Contract Controller
 * @summary changeAdrress
 */
export function changeAdrress(params: ChangeAdrressParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/changeAdrContract/${params.ctrid}` +
      prepareQueryParams({
        feesAmount: params.feesAmount,
        feesFormula: params.feesFormula,
        feesTax: params.feesTax,
        feesTaxcode: params.feesTaxcode,
        feesTaxrate: params.feesTaxrate,
        feescategory: params.feescategory,
        feestype: params.feestype,
        proctaskid: params.proctaskid,
        targetdate: params.targetdate,
        tpadrid: params.tpadrid,
        tpid: params.tpid,
      } as any)
  );
}
/**
 * @tags Fin Contract Controller
 * @summary EvollisExecuteContractOperation
 */
export function EvollisExecuteContractOperation(
  params: EvollisExecuteContractOperationParams
) {
  return request.get<AbstractResponse<object, object>>(
    `${URL}/api/EvollisExecuteContractOperation` +
      prepareQueryParams({
        Operation: params.Operation,
        id_transaction: params.id_transaction,
        salegrossamount: params.salegrossamount,
        salenetamount: params.salenetamount,
        saletaxamount: params.saletaxamount,
        targetdate: params.targetdate,
        targetstatus: params.targetstatus,
        tpidbuyer: params.tpidbuyer,
      } as any)
  );
}

export function EvollisExecuteContractOperationJob(
  params: EvollisExecuteContractOperationParams
) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/Evollis/ExecuteContractOperation` +
      prepareQueryParams({
        Operation: params.Operation,
        id_transaction: params.id_transaction,
        salegrossamount: params.salegrossamount,
        salenetamount: params.salenetamount,
        saletaxamount: params.saletaxamount,
        targetdate: params.targetdate,
        targetstatus: params.targetstatus,
        tpidbuyer: params.tpidbuyer,
      } as any)
  );
}

export interface ChangeDurationParams {
  ctrid: number;
  effectDate: string;
  newDuration: number;
  invoiceFees: boolean;
  feesFormula: string;
  feesAmount: number;
  mode: string; //CALCUL, SIMUL, REAL
  modid: number;
  taskid: number;
}

export interface RescheduleParams {
  ctrid: number;
  effectDate: string;
  gpDuration: number;
  gpMethod: string;
  gpPeriodicity: string;
  gpNominalRate: number;
  extendDuration: boolean;
  newRemainingDuration: number;
  newRate: number;
  newRv: number;
  newDueDate: string;
  defintMethod: string;
  defintNominalRate: number;
  invoiceFees: boolean;
  feesFormula: string;
  feesAmount: number;
  mode: string;
  modid: number;
  taskid: number;
  inPartialPayoffAmount: number;
  inPartialPayoffFormula: string;
  inPartialPayoffFeesAmount: number;
}

export interface ChangeDueDateParams {
  ctrid: number;
  effectDate: string;
  newDueDate: string;
  interestMethod: string;
  nominalRate: number;
  invoiceFees: boolean;
  feesFormula: string;
  feesAmount: number;
  mode: string; //CALCUL, SIMUL, REAL
  modid: number;
  taskid: number;
}

export interface ActivateContractOnAssetDeliveryParams {
  ActivationMode: string;
  Authorization: string;
  billingDate: string;
  ctduration: number;
  ctrid: number;
  deliveryDate: string;
  deliveryReference: string;
  depositAmount: number;
  finAmount: number;
  generateCommission: boolean;
  generateDisbursment: boolean;
  investAmount: number;
  invoiceDeferredinterest: boolean;
  invoiceDeposit: boolean;
  invoiceFirstrental: boolean;
  invoiceParticipation: boolean;
  invoiceUpfront: boolean;
  listAsset: string;
  participationAmount: number;
  residualValue: number;
  startDate: string;
  upfrontAmount: number;
}

/**
 * @tags Fin Contract Controller
 * @summary activateContractOnAssetDelivery
 */
export function changeDuration(params: ChangeDurationParams) {
  return request.put<AbstractResponse<FinContractResponse, object>>(
    `${URL}/api/changeDuration` +
      prepareQueryParams({
        ctrid: params.ctrid,
        effectDate: params.effectDate,
        newDuration: params.newDuration,
        invoiceFees: params.invoiceFees,
        feesFormula: params.feesFormula,
        feesAmount: params.feesAmount,
        mode: params.mode,
        modid: params.modid,
        taskid: params.taskid,
      } as any)
  );
}

export function reschedule(params: RescheduleParams) {
  return request.put<AbstractResponse<FinContractResponse, object>>(
    `${URL}/api/reschedule` +
      prepareQueryParams({
        ctrid: params.ctrid,
        effectDate: params.effectDate,
        gpDuration: params.gpDuration,
        gpMethod: params.gpMethod,
        gpPeriodicity: params.gpPeriodicity,
        gpNominalRate: params.gpNominalRate,
        extendDuration: params.extendDuration,
        newRemainingDuration: params.newRemainingDuration,
        newRate: params.newRate,
        newRv: params.newRv,
        newDueDate: params.newDueDate,
        defintMethod: params.defintMethod,
        defintNominalRate: params.defintNominalRate,
        invoiceFees: params.invoiceFees,
        feesFormula: params.feesFormula,
        feesAmount: params.feesAmount,
        mode: params.mode,
        modid: params.modid,
        taskid: params.taskid,
        inPartialPayoffAmount: params.inPartialPayoffAmount,
        inPartialPayoffFormula: params.inPartialPayoffFormula,
        inPartialPayoffFeesAmount: params.inPartialPayoffFeesAmount,
      } as any)
  );
}

export function changeDueDate(params: ChangeDueDateParams) {
  return request.put<AbstractResponse<FinContractResponse, object>>(
    `${URL}/api/changeDueDate` +
      prepareQueryParams({
        ctrid: params.ctrid,
        effectDate: params.effectDate,
        newDueDate: params.newDueDate,
        interestMethod: params.interestMethod,
        nominalRate: params.nominalRate,
        invoiceFees: params.invoiceFees,
        feesFormula: params.feesFormula,
        feesAmount: params.feesAmount,
        mode: params.mode,
        modid: params.modid,
        taskid: params.taskid,
      } as any)
  );
}

/**
 * @tags Fin Contract Controller
 * @summary activateContractOnAssetDelivery
 */
export function activateContractOnAssetDelivery(
  params: ActivateContractOnAssetDeliveryParams
) {
  return request.put<string>(
    `${URL}/api/activateContractOnAssetDelivery` +
      prepareQueryParams({
        ActivationMode: params.ActivationMode,
        billingDate: params.billingDate,
        ctduration: params.ctduration,
        ctrid: params.ctrid,
        deliveryDate: params.deliveryDate,
        deliveryReference: params.deliveryReference,
        depositAmount: params.depositAmount,
        finAmount: params.finAmount,
        generateCommission: params.generateCommission,
        generateDisbursment: params.generateDisbursment,
        investAmount: params.investAmount,
        invoiceDeferredinterest: params.invoiceDeferredinterest,
        invoiceDeposit: params.invoiceDeposit,
        invoiceFirstrental: params.invoiceFirstrental,
        invoiceParticipation: params.invoiceParticipation,
        invoiceUpfront: params.invoiceUpfront,
        listAsset: params.listAsset,
        participationAmount: params.participationAmount,
        residualValue: params.residualValue,
        startDate: params.startDate,
        upfrontAmount: params.upfrontAmount,
      } as any)
  );
}

export interface FindFinCTByAnyRefOrStatusOrDateParams {
  branchid: number;
  brokername: string;
  clientname: string;
  ctphase: string;
  ctreference: string;
  ctstatus: string;
  datemax: string;
  datemin: string;
  marketingid: number;
  network: string;
  offerid: number;
  prcode: string;
  propreference: string;
  tprefbroker: string;
  tpidbroker: number;
  clientreference: string;
  tpreference?: string;
  ctrid?: number;
  tpidsupplier?: number;
}

/**
 * @tags Fin Contract Controller
 * @summary findFinCTByAnyRefOrStatusOrDate
 */
export function findFinCTByAnyRefOrStatusOrDate(
  params: FindFinCTByAnyRefOrStatusOrDateParams
) {
  return request.get<AbstractResponse<object, FinCTListResponse>>(
    `${URL}/api/contract` +
      prepareQueryParams({
        branchid: params.branchid,
        brokername: params.brokername,
        clientname: params.clientname,
        ctphase: params.ctphase,
        ctstatus: params.ctstatus,
        datemax: params.datemax,
        datemin: params.datemin,
        marketingid: params.marketingid,
        network: params.network,
        offerid: params.offerid,
        prcode: params.prcode,
        ctreference: params.ctreference,
        propreference: params.propreference,
        tpidbroker: params.tpidbroker,
        tprefbroker: params.tprefbroker,
        clientreference: params.clientreference,
        tpreference: params?.tpreference,
        ctrid: params.ctrid,
        tpidsupplier: params.tpidsupplier,
      } as any)
  );
}

export interface CreateContractParams {
  ctRequest: FinContractRequest;
}

/**
 * @tags Fin Contract Controller
 * @summary createContract
 */
export function createContract(params: CreateContractParams) {
  return request.post<AbstractResponse<FinContractResponse, object>>(
    `${URL}/api/contract`,
    params.ctRequest
  );
}

export interface GetDecisionListByCtridParams {
  ctrid: number;
}

/**
 * @tags Fin Contract Controller
 * @summary getDecisionListByCtrid
 */
export function getDecisionListByCtrid(params: GetDecisionListByCtridParams) {
  return request.get<AbstractResponse<object, ConDecisionResponse>>(
    `${URL}/api/contract/decisionList/${params.ctrid}`
  );
}

export interface RestoreEventParams {
  comment?: string;
  ctrid: number;
  event: string;
  modid: number;
  proctaskid?: number;
}

/**
 * @tags Fin Contract Controller
 * @summary restoreEvent
 */
export function restoreEvent(params: RestoreEventParams) {
  return request.get<AbstractResponse<object, object>>(
    `${URL}/api/finModification/restore` +
      prepareQueryParams({
        comment: params.comment,
        ctrid: params.ctrid,
        event: params.event,
        modid: params.modid,
        proctaskid: params.proctaskid,
      } as any)
  );
}

export interface GenerateContractReferenceParams {
  ctphase: string;
  ctrid: number;
  ctstage: string;
  ctstatus: string;
}

/**
 * @tags Fin Contract Controller
 * @summary generateContractReference
 */
export function generateContractReference(
  params: GenerateContractReferenceParams
) {
  return request.put<AbstractResponse<FinContractResponse, object>>(
    `${URL}/api/contract/setContractReference` +
      prepareQueryParams({
        ctphase: params.ctphase,
        ctrid: params.ctrid,
        ctstage: params.ctstage,
        ctstatus: params.ctstatus,
      } as any)
  );
}

export interface UpdateFinContractStatusParams {
  ctphase: string;
  ctrid: number;
  ctstage: string;
  ctstatus: string;
  statusdate: string;
}

/**
 * @tags Fin Contract Controller
 * @summary updateFinContractStatus
 */
export function updateFinContractStatus(params: UpdateFinContractStatusParams) {
  return request.put<AbstractResponse<FinContractResponse, object>>(
    `${URL}/api/contract/status` +
      prepareQueryParams({
        ctphase: params.ctphase,
        ctrid: params.ctrid,
        ctstage: params.ctstage,
        ctstatus: params.ctstatus,
        statusdate: params.statusdate,
      } as any)
  );
}

export interface GetFinContractViewByTpidandDateParams {
  tpid: number;
  evalDate: string;
}

export function getFinContractViewByTpidandDate(
  params: GetFinContractViewByTpidandDateParams
) {
  return request.get<AbstractResponse<object, FinContractViewResponse>>(
    `${URL}/api/contract/view/byClient` +
      prepareQueryParams({
        tpid: params.tpid,
        evalDate: params.evalDate,
      } as any)
  );
}

export interface GetFinContractViewatEndOfTermParams {
  ctrid: number;
}

export function getFinContractViewatEndOfTerm(
  params: GetFinContractViewatEndOfTermParams
) {
  return request.get<AbstractResponse<FinContractViewResponse, object>>(
    `${URL}/api/contract/view/endOfTerm` +
      prepareQueryParams({
        ctrid: params.ctrid,
      } as any)
  );
}

export interface GetFinContractViewByIdandDateParams {
  ctrid: number;
  evalDate: string;
}

export function getFinContractViewByIdandDate(
  params: GetFinContractViewByIdandDateParams
) {
  return request.get<AbstractResponse<FinContractViewResponse, object>>(
    `${URL}/api/contract/view/byContract` +
      prepareQueryParams({
        ctrid: params.ctrid,
        evalDate: params.evalDate,
      } as any)
  );
}

export interface GetFinContractUsedAmountsParams {
  ctrid: number;
}

/**
 * @tags Fin Contract Controller
 * @summary getFinContractUsedAmounts
 */
export function getFinContractUsedAmounts(
  params: GetFinContractUsedAmountsParams
) {
  return request.get<AbstractResponse<CTUsedAmountResponse, object>>(
    `${URL}/api/contract/usedAmounts/${params.ctrid}`
  );
}

export interface GetFinContractByIdParams {
  ctrid: number;
}

export interface GetFinModificationByModidParams {
  modid: number;
}

export interface GetFinModificationValidByCtridParams {
  ctrid: number;
  modevent: string;
}

export interface GetFinContractFutureValueListParams {
  ctrid: number;
}

export function getFinModificationByModid(
  params: GetFinModificationByModidParams
) {
  return request.get<AbstractResponse<FinModificationResponse, object>>(
    `${URL}/api/finModification/${params.modid}`
  );
}

export function getFinModificationValidByCtrid(
  params: GetFinModificationValidByCtridParams
) {
  return request.get<AbstractResponse<object, FinModificationView>>(
    `${URL}/api/finModificationValid/contract/${params.ctrid}/${params.modevent}`
  );
}

export function getFinContractIrvScheduleList(
  params: GetFinContractFutureValueListParams
) {
  return request.get<AbstractResponse<object, IrvSchedule>>(
    `${URL}/api/contract/irvSchedule/${params.ctrid}`
  );
}
export function getFinContractFutureValueList(
  params: GetFinContractFutureValueListParams
) {
  return request.get<AbstractResponse<object, AssetFutureValueResponse>>(
    `${URL}/api/contract/futureValue/${params.ctrid}`
  );
}
/**
 * @tags Fin Contract Controller
 * @summary getFinContractById
 */
export function getFinContractById(params: GetFinContractByIdParams) {
  return request.get<AbstractResponse<FinContractResponse, object>>(
    `${URL}/api/contract/${params.ctrid}`
  );
}

export interface UpdateFinContractParams {
  ctRequest: FinContractRequest;
  ctrid: number;
}

/**
 * @tags Fin Contract Controller
 * @summary updateFinContract
 */
export function updateFinContract(params: UpdateFinContractParams) {
  return request.put<AbstractResponse<FinContractResponse, object>>(
    `${URL}/api/contract/${params.ctrid}`,
    params.ctRequest
  );
}

export function findFinModificationByAnyRefOrStatus(
  params: FindFinModificationByAnyRefOrStatusParams
) {
  return request.get<AbstractResponse<object, FinModification>>(
    `${URL}/api/finModification` +
      prepareQueryParams({
        ctreference: params.ctreference,
        modevent: params.modevent,
        modstatus: params.modstatus,
        ctrid: params.ctrid,
        modtype: params.modtype,
        creationuserid: params.creationuserid,
      } as any)
  );
}

export interface GetConStatusHistoryParams {
  ctrid: number;
}

/**
 * @tags Fin Contract Controller
 * @summary getConStatusHistory
 */
export function getConStatusHistory(params: GetConStatusHistoryParams) {
  return request.get<AbstractResponse<object, ConStatusResponse>>(
    `${URL}/api/contract/statusHistory/${params.ctrid}`
  );
}

/**
 * @tags Fin Contract Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/api/version`);
}

export interface ViewElementToReimburse {
  cteid: number;
  cteinvestamount: number;
  ctefinancedamount: number;
  ctedescription: string;
  ctetype: string;
  ctecategory: string;
  ctestatus: string;
  tpidclient: number;
  ctrid: number;
  ctreference: string;
  clientname: string;
  clientreference: string;
  ctestartdate: string;
  currcode: string;
  cteorder: number;
  cteenddate: string;
  ctervamount: number;
}

export interface GetElementsToReimbureseParams {
  tpidclient: number;
  currcode: string;
}

export function getElementsToReimburse(params: GetElementsToReimbureseParams) {
  return request.get<AbstractResponse<object, ViewElementToReimburse>>(
    `${URL}/api/elementToReimburse/${params.tpidclient}/${params.currcode}`
  );
}

export interface ViewElementToDisburse {
  cteid: number;
  cteinvestamount: number;
  ctefinancedamount: number;
  ctedescription: string;
  ctetype: string;
  ctecategory: string;
  ctestatus: string;
  tpidclient: number;
  ctrid: number;
  ctreference: string;
  clientname: string;
  clientreference: string;
  ctestartdate: string;
  currcode: string;
}
export interface GetElementsToDisburseParams {
  tpidclient: number;
  currcode: string;
}

export function getElementsToDisburse(params: GetElementsToDisburseParams) {
  return request.get<AbstractResponse<object, ViewElementToDisburse>>(
    `${URL}/api/elementToDisburse/${params.tpidclient}/${params.currcode}`
  );
}

export interface FindFinModificationByCtridParams {
  ctrid: number;
}

/**
 * @tags Fin Contract Controller
 * @summary findFinModificationByCtrid
 */
export function findFinModificationByCtrid(
  params: FindFinModificationByCtridParams
) {
  return request.get<AbstractResponse<object, FinModificationView>>(
    `${URL}/api/finModification/contract/${params.ctrid}`
  );
}

export interface GetTPOFFeesParams {
  ctrid: number;
  duedate: string;
  calculationbasis: string;
  nbMonths: number;
}

/**
 * @tags Fin Contract Controller
 * @summary findFinModificationByCtrid
 */
export function getTPOFFees(params: GetTPOFFeesParams) {
  return request.get<AbstractResponse<object, any>>(
    `${URL}/api/getTPOFFees` +
      prepareQueryParams({
        ctrid: params.ctrid,
        duedate: params.duedate,
        calculationbasis: params.calculationbasis,
        nbMonths: params.nbMonths,
      } as any)
  );
}

export interface AddConThirdPartyParams {
  ctrid: number;
  request: FinConThirdPartyRequest;
}

/**
 * @tags Fin Contract Controller
 * @summary addConThirdParty
 */
export function addConThirdParty(params: AddConThirdPartyParams) {
  return request.post<AbstractResponse<FinConThirdPartyResponse, object>>(
    `${URL}/api/finConThirdparty/${params.ctrid}`,
    params.request
  );
}

export interface runExtendContractElementsParams {
  ctridstart: number;
  ctridend: number;
  enddate: string;
  prcode: string;
  months_to_extend: number;
  jobid: number;
}

export function runExtendContractElements(
  params: runExtendContractElementsParams
) {
  return request.put<JobExecutionResponse>(
    `${URL}/api/run/extendCtElements` +
      prepareQueryParams({
        ctridstart: params.ctridstart,
        ctridend: params.ctridend,
        enddate: params.enddate,
        prcode: params.prcode,
        months_to_extend: params.months_to_extend,
        jobid: params.jobid,
      } as any)
  );
}

export interface GetPopulationToInvoiceByCriteriaParams {
  duedate: string;
  ctrid: number;
  mgid: number;
  citype: string;
  groupingmode: string;
  flagCalcAtDate: boolean;
  isSimulation: boolean;
}

/**
 * @tags Client Invoice Controller
 * @summary getPopulationToInvoiceByCriteria
 */
export function getPopulationToInvoiceByCriteria(
  params: GetPopulationToInvoiceByCriteriaParams
) {
  return request.get<AbstractResponse<object, object>>(
    `${URL}/api/contract/invoicingPopulation` +
      prepareQueryParams({
        duedate: params.duedate,
        ctridstart: params.ctrid,
        ctridend: params.ctrid,
        tpidclient: 0,
        citype: 'RENTAL',
        groupingmode: 'RENTAL',
        page: 1,
        mgid: params.mgid,
        flagCalcAtDate: params.flagCalcAtDate,
        isSimulation: params.flagCalcAtDate,
      } as any)
  );
}

export interface ReschUnpaidInvoiceParams {
  ctrid: number;
  effectDate: string;
  gpDuration: number;
  gpMethod: string;
  gpPeriodicity: string;
  gpNominalRate: number;
  extendDuration: boolean;
  newRemainingDuration: number;
  newRate: number;
  newRv: number;
  newDueDate: string;
  defintMethod: string;
  defintNominalRate: number;
  invoiceFees: boolean;
  feesFormula: string;
  feesAmount: number;
  mode: string;
  modid: number;
  taskid: number;
  totalunpaidamount: number;
  ciUpnaidList: Array<ClientInvoiceResponse>;
}

export function reschUnpaidInvoice(params: ReschUnpaidInvoiceParams) {
  return request.put<AbstractResponse<FinContractResponse, object>>(
    `${URL}/api/reschUnpaidInv` +
      prepareQueryParams({
        ctrid: params.ctrid,
        effectDate: params.effectDate,
        gpDuration: params.gpDuration,
        gpMethod: params.gpMethod,
        gpPeriodicity: params.gpPeriodicity,
        gpNominalRate: params.gpNominalRate,
        extendDuration: params.extendDuration,
        newRemainingDuration: params.newRemainingDuration,
        newRate: params.newRate,
        newRv: params.newRv,
        newDueDate: params.newDueDate,
        defintMethod: params.defintMethod,
        defintNominalRate: params.defintNominalRate,
        invoiceFees: params.invoiceFees,
        feesFormula: params.feesFormula,
        feesAmount: params.feesAmount,
        mode: params.mode,
        modid: params.modid,
        taskid: params.taskid,
        totalunpaidamount: params.totalunpaidamount
      } as any), 
      params.ciUpnaidList
  );
}
